import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IAccountRechargeDetail } from "../../../../AccountTypes";
import { useRechargeModel } from "./rechargeModel";

const columns: ColumnsType<IAccountRechargeDetail> = [
    {
        align: "center",
        title: '分支',
        dataIndex: 'branch',
    },

    {
        align: "center",
        title: '账户名称',
        dataIndex: 'accountName',
    },
    {
        align: "center",
        title: '授信类型',
        dataIndex: 'creditFlag',
        render: (v) => v === 1 ? '记账' : v === 0 ? '现结' : ''
    },
    {
        align: "center",
        title: '从属机构',
        dataIndex: 'orgName',
    },
    {
        align: "center",
        title: '账户实体',
        dataIndex: 'accountCode',
    },
    {
        align: "center",
        title: '原剩余金额',
        dataIndex: 'remainingAmount',
    },
    {
        align: "center",
        title: '充值金额',
        dataIndex: 'rechargeAmount',
    },
    {
        align: "center",
        title: '支付方式',
        dataIndex: 'payMethodName',
    },
    {
        align: "center",
        title: '收款人',
        dataIndex: 'operator',
    },
    {
        align: "center",
        title: '充值日期',
        dataIndex: 'createTime',
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },

];

export function RechargeDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useRechargeModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountRechargeDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
